import { createApp } from 'vue'
import Desi from './Desi.vue'
import './assets/global.css'

createApp(Desi).mount('#desi')
